import "./component-library133.mjs";
import normalizeComponent from "./component-library91.mjs";
const COL_PREFIX = "grid-column";
const _sfc_main = {
  name: "GridColumn",
  props: {
    xs: { type: [Number, Boolean], default: false },
    sm: { type: [Number, Boolean], default: false },
    md: { type: [Number, Boolean], default: false },
    lg: { type: [Number, Boolean], default: false },
    xl: { type: [Number, Boolean], default: false },
    xsShrink: { type: Boolean },
    smShrink: { type: Boolean },
    mdShrink: { type: Boolean },
    lgShrink: { type: Boolean },
    xlShrink: { type: Boolean },
    xsOffset: { type: Number, default: void 0 },
    smOffset: { type: Number, default: void 0 },
    mdOffset: { type: Number, default: void 0 },
    lgOffset: { type: Number, default: void 0 },
    xlOffset: { type: Number, default: void 0 },
    xsSpacing: { type: Number, default: void 0 },
    smSpacing: { type: Number, default: void 0 },
    mdSpacing: { type: Number, default: void 0 },
    lgSpacing: { type: Number, default: void 0 },
    xlSpacing: { type: Number, default: void 0 },
    noPadding: { type: Boolean }
  },
  computed: {
    colClassList() {
      const list = [COL_PREFIX];
      if (!(this.xs || this.sm || this.md || this.lg || this.xl)) {
        list.push(`${COL_PREFIX}--is-simple`);
      } else {
        ["xs", "sm", "md", "lg", "xl"].forEach((viewport) => {
          if (this[viewport] === true) {
            list.push({ [`${COL_PREFIX}--${viewport}`]: this[viewport] });
          } else {
            list.push({
              [`${COL_PREFIX}--${viewport}-${this[viewport]}`]: this[viewport]
            });
          }
        });
      }
      const shrinkNames = Object.keys(this.$props).filter((name) => name.includes("Shrink"));
      shrinkNames.forEach((viewport) => {
        if (!this[viewport]) {
          return;
        }
        list.push(`${COL_PREFIX}--${viewport.replace("Shrink", "-shrink")}`);
      });
      const offsetNames = Object.keys(this.$props).filter((name) => name.includes("Offset"));
      offsetNames.forEach((viewport) => {
        if (!this[viewport]) {
          return;
        }
        list.push(`${COL_PREFIX}--${viewport.replace("Offset", "-offset")}-${this[viewport]}`);
      });
      const spacingNames = Object.keys(this.$props).filter((name) => name.includes("Spacing"));
      spacingNames.forEach((viewport) => {
        if (!this[viewport]) {
          return;
        }
        list.push(`${COL_PREFIX}--${viewport.replace("Spacing", "-spacing")}-${this[viewport]}`);
      });
      if (this.noPadding) {
        list.push(`${COL_PREFIX}--no-padding`);
      }
      return list;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { class: _vm.colClassList }, [_vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "b90fee99",
  null,
  null
);
const GridColumn = __component__.exports;
export {
  GridColumn as default
};
